import type { Components, Theme } from "@mui/material/styles";

export const MuiPaper: Components<Theme>["MuiPaper"] = {
  defaultProps: {
    square: true,
    elevation: 0,
  },
  styleOverrides: {
    outlined: ({ theme }) => ({
      borderColor: theme.palette.grey[300],
    }),
  },
};
